"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPOCH_J2100 = exports.EPOCH_J2000 = exports.EPOCH_J1950 = exports.EPOCH_J1900 = void 0;
exports.EPOCH_J1900 = 2415020.0;
exports.EPOCH_J1950 = 2433282.5;
exports.EPOCH_J2000 = 2451545.0;
exports.EPOCH_J2100 = 2488070.0;
